<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    
    <div :class="{'fixed-header':fixedHeader}">
        <OALogo class="head-logo" />
        <OASidebar class="sidebar-container" />
        <OANavbar />
    </div>
    <div class="main-container">
      <OAAppMain />
    </div>
  </div>
</template>

<script>
import { OANavbar, OALogo, OASidebar, OAAppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'OfficeLayout',
  components: {
    OANavbar,
    OALogo,
    OASidebar,
    OAAppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
   
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: 100%;
    transition: width 0.28s;
    height: 64px;
    border-bottom: 1px solid #eceef1;
    line-height: 64px;
    padding: 0px 20px;
    background-color: #fff;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
  .leftSide{
    width: 210px;
    /*
    position: fixed;
    top:64px;
    bottom: 0;
    left: 0;
    */
    height: 100%;
    overflow: hidden;
    /*padding-top: 20px;*/
    background-color: #fff;
    border-right: 1px solid #eceef1;
    
  }
  .leftSide .el-menu{
     border-right: none
  }
  .main-container{
    position: relative;
    top:68px;
  }
  .left{
     position: absolute;
    }
    .pd20{
      padding: 20px;
    }
</style>
